import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/why-choose-2.jpg'
import _imports_1 from '@/assets/images/why-choose-6.jpg'
import _imports_2 from '@/assets/images/why-choose-4.jpg'


const _hoisted_1 = { class: "why-choose-area bg-gray3 pt-100" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  class: "col-lg-4 col-md-12 mb-4 mb-lg-0",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}
const _hoisted_5 = {
  class: "col-lg-6 col-md-12 mb-4 mb-lg-0",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "300"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-4 col-md-6" }
const _hoisted_8 = {
  class: "col-lg-2 col-md-12",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "section-title mw-860 m-auto text-center",
        "data-aos": "fade-up",
        "data-aos-duration": "1000",
        "data-aos-delay": "100"
      }, [
        _createElementVNode("span", { class: "top-title" }, "لماذا تختار سيرفرنا؟"),
        _createElementVNode("h2", null, "لأن خدماتنا تضمن لك جودة بث مختلفة عن الجميع")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "why-choose-single-item bg-img h-100",
            style: _normalizeStyle({ backgroundImage: `url(${_ctx.bgImage1})` })
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "why-choose-content" }, [
              _createElementVNode("h3", null, [
                _createElementVNode("span", null, "سرعة اتّصال"),
                _createElementVNode("span", null, "فائقة وقوية")
              ]),
              _createElementVNode("p", null, "استمتع بتجربة تنقّل فوري بين القنوات بفضل خوادمنا السريعة في أوروبا.")
            ], -1)
          ]))], 4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"col-lg-8 col-md-6 mb-4 mb-md-0\"><div class=\"bg-secondary why-choose-single-item\"><div class=\"row align-items-center\"><div class=\"col-lg-6\"><div class=\"why-choose-content p-0\"><h3><span>ثبات واستقرار</span><span>غير مشروط</span></h3><p> شبكتنا المدعومة بأحدث التقنيات تضمن لك بثاً مستقراً تماماً ومقاوماً للحظر أثناء المباريات الكبرى. </p></div></div><div class=\"col-lg-6\"><div class=\"why-choose-img-2\"><img src=\"" + _imports_0 + "\" alt=\"why-choose\"></div></div></div></div></div>", 1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "bg-img why-choose-single-item h-100 overly",
                style: _normalizeStyle({ backgroundImage: `url(${_ctx.bgImage2})` })
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("div", { class: "why-choose-content" }, [
                  _createElementVNode("h3", null, [
                    _createElementVNode("span", null, "جودة"),
                    _createElementVNode("span", null, "4K و Ultra HD")
                  ]),
                  _createElementVNode("p", null, "تابع قنواتك المفضلة والبطولات الرياضية بأعلى دقة ووضوح متاحين.")
                ], -1)
              ]))], 4)
            ]),
            _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"col-lg-12\"><div class=\"why-choose-single-item bg-color\"><div class=\"row align-items-center\"><div class=\"col-lg-5 col-sm-6\"><div class=\"why-choose-6\"><img src=\"" + _imports_1 + "\" alt=\"why-choose\"></div></div><div class=\"col-lg-7 col-sm-6\"><div class=\"why-choose-content\"><h3><span>سيرفرات مخصصة</span><span>لألمانيا وأوروبا</span></h3><p> نحن نعتمد على بنية تحتية فائقة القوة موزعة جغرافياً لتغطية كامل مدن ألمانيا والدول الأوروبية بكفاءة عالية وجودة مستمرة وضمان رضاء كامل. </p></div></div></div></div></div>", 1))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "why-choose-single-item bg-img h-100",
            style: _normalizeStyle({ backgroundImage: `url(${_ctx.bgImage3})` })
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("div", { class: "why-choose-content" }, [
              _createElementVNode("h3", null, [
                _createElementVNode("span", null, "أسعار"),
                _createElementVNode("span", null, "واضحة وشفافة"),
                _createElementVNode("span", null, "تماماً")
              ]),
              _createElementVNode("p", null, "باقات مرنة ومناسبة بدون أي تكاليف مخفية أو رسوم إضافية للمعدات.")
            ], -1),
            _createElementVNode("div", { class: "why-choose-4" }, [
              _createElementVNode("img", {
                src: _imports_2,
                alt: "why-choose"
              })
            ], -1)
          ]))], 4)
        ])
      ])
    ])
  ]))
}